// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"104": "36bb5fe0","3046": "b63cef43","804": "6166aec1","8357": "dd422574",}[chunkId] + ".css"
}